export { default } from './TextImage';



// WEBPACK FOOTER //
// ./src/components/templates/TextImage/index.js